export default {
  ASSIGNE: "assigne",
  WORKER: "worker",
  ADMIN: "admin",
  SUPERUSER: "superu",
  COMMERCIO: "commercio",
  EXTERNAL: "external",
};
